export default __webpack_public_path__ + "static/ensino-intencional-629202ef5042ebd1a8536e28581a4572.png";